import { HiOutlineUserGroup, HiOutlineSpeakerphone } from 'react-icons/hi';
import { RiStore2Fill, RiSettings5Fill } from 'react-icons/ri';
import { TiShoppingCart } from 'react-icons/ti';
import { BsPersonFill } from 'react-icons/bs';
import { GrNotes } from 'react-icons/gr';
import moment from 'moment';

export const API_INFO = process.env.REACT_APP_API_INFO;
export const COIN = process.env.REACT_APP_COIN;
export const CURRENCY_POSITION = process.env.REACT_APP_CURRENCY_POSITION;
export const MAP_KEY = process.env.REACT_APP_API_KEY_MAPS;
export const othersFilters = ['books', 'products', 'is_ebook', 'idioma'];

export const searchChoiceData = (t) => {
  const SPANISH_OPTION_DATA = { label: t('espanol', { ns: 'header' }), value: '1', name: 'idioma' };
  const ENGLISH_OPTION_DATA = { label: t('english', { ns: 'header' }), value: '6', name: 'idioma' };
  const CATALAN_OPTION_DATA = { label: t('catalan', { ns: 'header' }), value: '2', name: 'idioma' };
  const GALLEGO_OPTION_DATA = { label: t('galician', { ns: 'header' }), value: '4', name: 'idioma' };
  const PORTUGUESE_OPTION_DATA = { label: t('portuguese', { ns: 'header' }), value: '10', name: 'idioma' };
  const EUSKERA_OPTION_DATA = { label: t('euskera', { ns: 'header' }), value: '136', name: 'idioma' };
  const FRANCES_OPTION_DATA = { label: t('frances', { ns: 'header' }), value: '7', name: 'idioma' };

  const EBOOK_OPTION_DATA = { label: t('digitalBook'), value: 'ebook', name: 'is_ebook' };
  const BOOK_OPTION_DATA = { label: t('paperBook'), value: 'book', name: 'is_ebook' };

  const ALLCATALOG_OPTION_DATA = { label: t('throughoutCatalog'), value: 'products', name: 'searchType' };
  const INSIDEBOOKS_OPTION_DATA = { label: t('insideBooks'), value: 'books', name: 'searchType' };
  const TITLE_OPTION_DATA = { label: t('title'), value: 'titulo', name: 'searchType' };
  const AUTHOR_OPTION_DATA = { label: t('author'), value: 'autor', name: 'searchType' };
  const EDITORIAL_OPTION_DATA = { label: t('Editorial'), value: 'editorial', name: 'searchType' };
  const EAN_OPTION_DATA = { label: 'I.S.B.N.', value: 'ean', name: 'searchType' };

  const SEARCH_OPTIONS_DATA = [
    ALLCATALOG_OPTION_DATA,
    //INSIDEBOOKS_OPTION_DATA,
    TITLE_OPTION_DATA,
    AUTHOR_OPTION_DATA,
    EDITORIAL_OPTION_DATA,
    EAN_OPTION_DATA,
  ];

  const FILTER_BY_PRODUCT_TYPE_OPTIONS_DATA = [EBOOK_OPTION_DATA, BOOK_OPTION_DATA];

  const FILTER_BY_LANGUAGE_OPTIONS_DATA = [
    SPANISH_OPTION_DATA,
    ENGLISH_OPTION_DATA,
    CATALAN_OPTION_DATA,
    GALLEGO_OPTION_DATA,
    PORTUGUESE_OPTION_DATA,
    EUSKERA_OPTION_DATA,
    FRANCES_OPTION_DATA,
  ];

  const SEARCH_TYPE_DIVISION_DATA = { name: t('searchArea'), optionsData: SEARCH_OPTIONS_DATA };

  const FILTER_BY_LANGUAGE_DIVISION_DATA = {
    name: t('searchLanguage'),
    optionsData: FILTER_BY_LANGUAGE_OPTIONS_DATA,
  };

  const FILTER_BY_PRODUCT_TYPE_DIVISION_DATA = {
    name: t('searchTypeProduct'),
    optionsData: FILTER_BY_PRODUCT_TYPE_OPTIONS_DATA,
  };

  const FORM_RADIO_OPTIONS_DIVISIONS = [
    SEARCH_TYPE_DIVISION_DATA,
    //FILTER_BY_PRODUCT_TYPE_DIVISION_DATA,
    //FILTER_BY_LANGUAGE_DIVISION_DATA,
  ];
  return FORM_RADIO_OPTIONS_DIVISIONS;
};

export const choicesInvoice = (t, includeNone = true) => {
  const choices = [
    {
      id: 'paid',
      value: t('orderTrans.paid'),
    },
    {
      id: 'notPaid',
      value: t('orderTrans.notPaid'),
    },
    {
      id: 'cancelled',
      value: t('orderTrans.cancelled'),
    },
    {
      id: 'expired',
      value: t('orderTrans.expired'),
    },
    {
      id: 'pending',
      value: t('orderTrans.Pending'),
    },
    {
      id: 'pendingPayment',
      value: t('orderTrans.pendingPayment'),
    },
  ];

  if (includeNone) {
    choices.unshift({
      id: '',
      value: t('faqs.none'),
    });
  }

  return choices;
};

export const choicesSearch = (t) => {
  return [
    {
      id: 'ninguno',
      value: t('faqs.none'),
    },
    {
      id: 'true',
      value: t('activo'),
    },
    {
      id: 'false',
      value: t('faqs.inactive'),
    },
  ];
};

export const choicesCommentsLibraryShow = (t) => {
  return [
    {
      id: 'todos',
      value: t('commentLibrary.all'),
    },
    {
      id: 'true',
      value: t('commentLibrary.shown'),
    },
    {
      id: 'false',
      value: t('commentLibrary.notShown'),
    },
  ];
};

export const choicesUserType = (t) => {
  return [
    {
      id: 'normal',
      value: t('normal'),
    },
    {
      id: 'library',
      value: t('library'),
    },
    {
      id: 'school',
      value: t('school'),
    },
    {
      id: 'worker',
      value: t('worker'),
    },
    {
      id: 'commercial',
      value: t('commercial'),
    },
  ];
};

export const choicesSliderCategories = (t) => {
  return [
    {
      id: '',
      value: t('all'),
    },
    {
      id: 'home',
      value: t('home'),
    },
    {
      id: 'book',
      value: t('books'),
    },
    {
      id: 'film',
      value: t('cinema'),
    },
    {
      id: 'music',
      value: t('music'),
    },
  ];
};

export const getContentProduct = (t, search = false) => {
  return search
    ? [
        { id: 'Ninguno', value: t('faqs.none') },
        { id: 'Libro', value: t('books') },
        // { id: 'Cine', value: t('cinema') },
        // { id: 'Musica', value: t('music') },
        //{ id: 'Merchandising', value: t('merchandising') },
      ]
    : [
        { id: 1, value: t('Todo') },
        { id: 2, value: t('books') },
        //{ id: 3, value: t('cinema') },
        //{ id: 4, value: t('music') },
        //{ id: 5, value: t('merchandising') },
      ];
};

export const getLocationWeb = (t) => {
  return [
    { id: 'none', value: t('faqs.none') },
    { id: 'home', value: t('home') },
    { id: 'book', value: t('books') },
  ];
};

export const getProductType = (t) => {
  return [
    { id: 'book', value: t('books') },
    { id: 'merchandising', value: t('merchandising') },
  ];
};

export const getGenders = (t) => {
  return [
    { id: 'adulto', value: t('adulto') },
    { id: 'infantil', value: t('infantil') },
  ];
};

export const getLocationWebEdit = (t) => {
  return [
    { id: 'Ninguno', value: t('faqs.none') },
    { id: 'Inicio', value: t('Home') },
    { id: 'Books', value: t('Books') },
  ];
};

export const getKeyword = (t) => {
  return [
    { id: '#books', value: t('books') },
    { id: '#blog', value: t('blog') },
    { id: '#infantil', value: t('infantil') },
    { id: '#gallery', value: t('gallery') },
    { id: '#ebooks', value: t('Ebooks') },
  ];
};

export const MONTH_DIS = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const latinCharsRegex = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]{1,45})$/;
export const phoneRegex = /^([0-9\s]{6,20})$/;
export const orderRegex = /^([0-9]{3,6})$/;
export const themeBase =
  ':root{--color-primario:#000000;--color-secundario:#D9DBDE;--color-terciario:#0069d9;--color-sombra:#8f8f8f;--texto-primario:#000000;--texto-secundario:#FFFFFF;--boton-primario:#0069d9;--boton-secundario:#FFFFFF;--fuente-primaria: montserrat;--color-green:#aec933;}';
export const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1700 },
    items: 6,
  },
  desktop: {
    breakpoint: { max: 1700, min: 1200 },
    items: 5,
    // partialVisibilityGutter: 80,
  },
  miniDesktop: {
    breakpoint: { max: 1200, min: 992 },
    items: 4,
    // partialVisibilityGutter: 80,
  },
  tablet: {
    breakpoint: { max: 991, min: 768 },
    items: 4,
    // partialVisibilityGutter: 70,
  },
  mobile: {
    breakpoint: { max: 768, min: 200 },
    items: 2,
  },
  miniMobile: {
    breakpoint: { max: 200, min: 0 },
    items: 1,
  },
};

export const PRODUCT_STATUS = [
  {
    id: 0,
    value: 'product.requested',
  },
  {
    id: 1,
    value: 'product.received',
  },
  {
    id: 2,
    value: 'product.outOfStock',
  },
  {
    id: 3,
    value: 'product.discontinued',
  },
  {
    id: 4,
    value: 'product.voided',
  },
  {
    id: 5,
    value: 'product.shipped',
  },
  {
    id: 6,
    value: 'product.duplicated',
  },
];

export const ORDER_STATUS = [
  {
    id: 'pending',
    value: 'product.outstanding',
  },
  {
    id: 'processing',
    value: 'orderTrans.processed',
  },
  {
    id: 'shipped',
    value: 'product.shipped',
  },
  {
    id: 'received_customer',
    value: 'product.receivedCustomer',
  },
  {
    id: 'cancelled',
    value: 'orderTrans.cancelled',
  },
  {
    id: 'returned',
    value: 'product.returned',
  },
  {
    id: 'incomplete',
    value: 'orderTrans.incomplete',
  },
  {
    id: 'refunded',
    value: 'orderTrans.refunded',
  },
  {
    id: 'managed',
    value: 'orderTrans.managed',
  },
];

export const getProductStatus = (t) => {
  return PRODUCT_STATUS.map((item) => ({
    ...item,
    value: t(item.value),
  }));
};

export const getOrderStatus = (t) => {
  return ORDER_STATUS.map((item) => ({
    ...item,
    value: t(item.value),
  }));
};

export const getPaymentStatus = (t) => {
  return [
    { id: 'pending', value: t('orderTrans.Pending') },
    { id: 'paid', value: t('orderTrans.paid') },
    { id: 'cash_delivery', value: t('orderTrans.cashOnDelivery') },
  ];
};

export const getPaymentMethod = (t) => {
  return [
    { id: 1, value: t('orderTrans.wireTransfer') },
    { id: 4, value: t('orderTrans.tpv') },
    /* { id: 2, value: t('orderTrans.paypal') },
    { id: 3, value: t('orderTrans.cashOnDelivery') }, */
    /* { id: 5, value: t('orderTrans.paymentInStore') }, */
  ];
};

export const getHeaderArticles = (t, options = {}) => {
  const { includeProductBookStatus = false } = options;
  const cols = [
    {
      name: t('ean'),
      size: 2,
      key: 'ean',
    },
    {
      name: t('name'),
      size: 2,
      key: 'title',
    },
    {
      name: t('product.editorial'),
      size: 1,
      key: 'editorial',
    },
    {
      name: `${t('product.unitPrice')}(${COIN})`,
      size: 1,
      key: 'precio_venta',
    },
    {
      name: t('product.quantity'),
      size: 1,
      key: 'quantity',
    },
    {
      name: `${t('product.discount')} (%)`,
      size: 1,
      key: 'descuento',
    },
    {
      name: `${t('product.totalPrice')}(${COIN})`,
      size: 1,
      key: 'total',
    },
  ];
  if (includeProductBookStatus) {
    cols.push({
      name: '',
      size: 1,
      key: 'book_product_status',
    });
  }
  cols.push({
    name: t('state'),
    size: includeProductBookStatus ? 1 : 2,
    key: 'estado',
  });
  return cols;
};

export const menu_backoffice = [
  {
    id: 1,
    title: 'catalogo',
    icon: <GrNotes />,
    subMenu: [
      {
        id: 1,
        title: 'products',
        endpoint: 'products',
        permission: 'producto.__view',
      },
      /*{
        id: 2,
        title: 'importar',
        endpoint: 'imports',
      },*/
      {
        id: 3,
        title: 'editoriales',
        endpoint: 'editorials',
        permission: 'editorial.__view',
      },
      {
        id: 4,
        title: 'autores',
        endpoint: 'authors',
        permission: 'autor.__view',
      },
      /*{
        id: 5,
        title: 'cupones',
        endpoint: 'coupons',
      },*/
    ],
  },
  {
    id: 2,
    title: 'clientes',
    icon: <HiOutlineUserGroup />,
    subMenu: [
      {
        id: 1,
        title: 'usuarios',
        endpoint: 'users',
        permission: 'user.__view',
      },
      {
        id: 2,
        title: 'suscripciones',
        endpoint: 'email-subscriptions',
        permission: 'suscripcionboletin.__view',
      },
      /*{
        id: 3,
        title: 'comentariosLibros',
        endpoint: 'comments',
      },
      {
        id: 4,
        title: 'mensajes',
        endpoint: 'client-messages',
      },*/
    ],
  },
  {
    id: 3,
    title: 'webManagement',
    icon: <RiSettings5Fill />,
    subMenu: [
      {
        id: 1,
        title: 'listas',
        endpoint: 'lists',
        permission: 'lista.__view',
      },
      {
        id: 2,
        title: 'sliders',
        endpoint: 'sliders',
        permission: 'sliderclient.__view',
      },
      {
        id: 3,
        title: 'faqs.faqs',
        endpoint: 'faqs',
        permission: 'faq.__view',
      },
      {
        id: 4,
        title: 'posts',
        endpoint: 'posts',
        permission: 'post.__view',
      },
      {
        id: 5,
        title: 'gallery',
        endpoint: 'gallery',
        permission: 'gallery.__view',
      },
      {
        id: 6,
        title: 'Menú',
        endpoint: 'menu',
        permission: 'gallery.__view',
      },
      {
        id: 7,
        title: 'menuMatters',
        endpoint: 'menu-matters',
        permission: 'empresa.__view',
      },
      {
        id: 8,
        title: 'Texto de ayuda',
        endpoint: 'help-text',
        permission: 'gallery.__view',
      },
      {
        id: 9,
        title: 'awardWinningBooks',
        endpoint: 'award-winning-books',
        permission: 'gallery.__view',
      },
      {
        id: 10,
        title: 'recommendBookstores',
        endpoint: 'recommend-bookstores',
        permission: 'gallery.__view',
      },
    ],
  },
  {
    id: 4,
    title: 'ventas',
    icon: <TiShoppingCart />,
    subMenu: [
      {
        id: 1,
        title: 'pedidos',
        endpoint: 'purchases',
        permission: 'pedido.__commission_view',
      },
      {
        id: 2,
        title: 'facturas',
        endpoint: 'invoices',
        permission: 'invoice.__view',
      },
      {
        id: 3,
        title: 'contests',
        endpoint: 'contests',
        permission: 'concourse.__view',
      },
     /*  {
        id: 4,
        title: 'commissions',
        endpoint: 'commissions',
        permission: 'pedido.__commission_view',
      }, */
    ],
  },
  {
    id: 5,
    title: 'stock',
    icon: <RiStore2Fill />,
    subMenu: [
      {
        id: 1,
        title: 'ordersToSupplier',
        endpoint: 'order-suppliers',
        permission: 'ordersuppliers.__view',
      },
      {
        id: 2,
        title: 'distributor',
        endpoint: 'distributor',
        permission: 'distributor.__view',
      },
    ],
  },
  {
    id: 14,
    title: 'marketing',
    icon: <HiOutlineSpeakerphone />,
    subMenu: [
      /*{
        id: 1,
        title: 'publicacionesDeBlog',
        endpoint: 'blog-posts',
      },
      {
        id: 2,
        title: 'publicacionesLibrosMes',
        endpoint: 'books-of-the-month-posts',
      },
      {
        id: 3,
        title: 'librosDelMes',
        endpoint: 'books-of-the-month',
      },*/
      {
        id: 5,
        title: 'promoCodes.promoCodesTitle',
        endpoint: 'promotionalCodes',
        permission: 'promocode.__view',
      },
      {
        id: 6,
        title: 'agenda',
        endpoint: 'schedules',
        permission: 'schedule.__view',
      },
    ],
  },
  {
    id: 15,
    title: 'administracion',
    icon: <BsPersonFill />,
    subMenu: [
      {
        id: 1,
        title: 'librerias',
        endpoint: 'bookstores',
        permission: 'empresa.__view',
      },
    /*   {
        id: 2,
        title: 'deliveries',
        endpoint: 'deliveries',
        permission: 'empresa.__view',
      }, */
      {
        id: 3,
        title: 'configuration',
        endpoint: 'configuration',
        permission: 'empresa.__view',
      },
      /*  {
        id: 4,
        title: 'commentLibrary.title',
        endpoint: 'comments-library',
        permission: 'empresa.__view',
      }, */
      /* {
        id: 5,
        title: 'affiliationRequest',
        endpoint: 'affiliation-request',
        permission: 'empresa.__view',
      }, */
    ],
  },
];
